"use strict";

/**
* Initializes event handlers for the vehicle selector component.
* - Handles dropdown changes to trigger AJAX requests for vehicle filtering and updates the UI accordingly.
* - Manages tab switching by toggling active states and displaying the relevant tab content.
* - Submits the vehicle search form when the search button is clicked.
*
* @function
* @returns {void}
*/
function init() {
    var $document = $(document);

    $document.on("change", ".vehicle-selector-dropdown", function () {
        var $this = $(this);
        var selectedValue = $this.val();
        var selectedFilter = $this.data("filterby");

        var $container = $(".vehicle-selector-container");
        var url = $container.data("url");
        var pid = $container.data("pid");
        var isSearchRestrictedToFordVehicles = $container.data("isRestrictedToFordVehicles");

        if (url) {
            $.spinner().start();
            $.ajax({
                url: url,
                data: {
                    selectedFilter: selectedFilter,
                    selectedValue: selectedValue,
                    isSearchRestrictedToFordVehicles: isSearchRestrictedToFordVehicles,
                    pid: pid
                },
                method: "GET",
                success: function (response) {
                    // updates the dropdowns refinements based on the selected filters
                    $(".js-vehicle-selector-dropdowns").html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    $document.on("click", ".vehicle-selector-tab", function () {
        var $this = $(this);
        var isActive = $this.hasClass("active");

        if (isActive) {
            return;
        }

        // removes the active class from all tabs and adds it to the selected one
        $(".vehicle-selector-tab").removeClass("active");
        $this.addClass("active");

        // hides all tab containers and shows only the selected one
        var tabContainer = $this.data("tab-container");

        $(".vehicle-selector-tab-container").addClass("d-none");
        $("." + tabContainer).removeClass("d-none");
    });

    $document.on("click", "#vehicle-selector-search-btn", function (e) {
        e.preventDefault();
        $(".vehicle-selector-searcher").find("form").submit();
    });

    // listener for the remove vehicle button in the PDP, Home and PLP
    $(".js-vehicle-selector-pdp-remove, .js-vehicle-selector-remove").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var url = $this.data("url");
        var href = $this.attr("href");

        if (url) {
            $.spinner().start();
            $.ajax({
                url: url,
                method: "GET",
                success: function () {
                    $.spinner().stop();

                    if (href && href !== "#" && href !== "") {
                        window.location.href = href;
                    } else {
                        var currentUrl = new URL(window.location.href);
                        var keysToDelete = [];

                        currentUrl.searchParams.forEach(function (value, key) {
                            if (typeof value === "string" && (value.includes("marca") || value.includes("modelo") || value.includes("ano") || value.includes("version"))) {
                                keysToDelete.push(key);
                                keysToDelete.push(key.replace("n", "v"));
                            }
                        });

                        keysToDelete.forEach(function (key) {
                            currentUrl.searchParams.delete(key);
                        });

                        currentUrl.searchParams.set("clearVehicle", new Date().getTime());

                        window.location.href = currentUrl.toString();
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    });

    // listener for the verify vehicle button in the PDP
    $(".js-vehicle-selector-pdp-verify").on("click", function (e) {
        e.preventDefault();

        var areAllPartsSelected = true;

        // it skips the "version" dropdown as it is not mandatory
        $(".vehicle-selector-dropdown").not("[data-filterby='version']").each(function () {
            var $this = $(this);
            var selectedValue = $this.val();

            if (selectedValue === "0") {
                areAllPartsSelected = false;

                $this.siblings(".js-required").removeClass("d-none");
                $this.addClass("dropdown-required");

                setTimeout(function () {
                    $this.removeClass("dropdown-required");
                }, 3000);
            }
        });

        if (areAllPartsSelected) {
            // reloads the page
            location.reload(true);
        }
    });

    // listener for search button in the home page
    $("#js-vehicle-selector-search-button").on("click", function (e) {
        e.preventDefault();

        var url = $(this).attr("href");
        var filterCounter = 1;

        $(".vehicle-selector-dropdown").each(function () {
            var $this = $(this);
            var selectedValue = $this.val();
            var filterBy = $this.data("filterby");

            if (selectedValue !== "0" && filterBy) {
                url += "&prefn" + filterCounter + "=" + filterBy + "&prefv" + filterCounter + "=" + selectedValue;
                filterCounter++;
            }
        });

        window.location.href = url;
    });
}

export default function vehicleSelector() {
    init();
}
